import { render, staticRenderFns } from "./SwapLogs.vue?vue&type=template&id=02b44cca&scoped=true"
import script from "./SwapLogs.vue?vue&type=script&lang=js"
export * from "./SwapLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b44cca",
  null
  
)

export default component.exports